import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {TicketingQuestionEditorBoxProps} from './ticketing-question-editor-box.types';

export function TicketingQuestionEditorBox({displayNumber, children}: TicketingQuestionEditorBoxProps): ReactElement {
  return (
    <div className="gap-3 bg-neutral-alt-primary-default flex-column-align-start spacing-p-3 corner-radius-8 _full-width">
      <Text className="ct-neutral-primary" val={window.i18next.t('pmwjs_event_ticketing_question_number', {n: displayNumber})} size={TextSize.SM} />
      {children}
    </div>
  );
}
